import { ModuleConsts } from 'client/util/Constants';
import { get } from 'lodash';
import DateUtil from 'client/util/DateUtil';
import PasswordStatusUtil from 'client/util/PasswordStatusUtil';

const { mfaStates } = ModuleConsts.systemUser;

/**
 * This mixin was created to centralize how we compute user states in our components
 * provided that the entire user item is passed to it.
 */
export default {
  computed: {
    passwordStatus() {
      return PasswordStatusUtil.getPasswordStatus(this.item);
    },
    /**
     * Returns the difference in the number of days left until the user's password expires. Mainly
     * used to determine the color of the the expiration date. If the password has expired or
     */
    passwordExpirationNumDays() {
      const { item } = this;
      const passwordExpirationDate = item.password_expiration_date;
      return (!passwordExpirationDate || item.password_expired)
        ? undefined : DateUtil.daysUntil(passwordExpirationDate);
    },

    /**
     * Computes the status of the users MFA. See the mfaTruthTable above to see all possible states.
     * https://docs.google.com/spreadsheets/d/19XxBe5vMytecD8A6Qz4UGpNeKAgwK1ao4mWh2R6yrYk/edit#gid=0
     */
    mfaStatus() {
      const { item } = this;
      const mfaEnabled = item.enable_user_portal_multifactor;
      const mfaConfigured = get(item, 'mfa.configured', undefined);
      const exclusion = get(item, 'mfa.exclusion', undefined);
      const exclusionDays = get(item, 'mfa.exclusionDays', undefined);
      const exclusionUntil = get(item, 'mfa.exclusionUntil', undefined);
      const {
        active, enrollment, enrollmentExpired, inactive,
      } = mfaStates;

      // Compute the mfa status
      if (mfaConfigured) {
        // The user has successfully setup MFA
        return active;
      }

      if (exclusion && (exclusionDays || exclusionUntil)) {
        // The user has not setup MFA and is in an enrollment period
        return enrollment;
      }

      if (!mfaEnabled) {
        // The user has not setup MFA, is not in enrollment, and is not required to have MFA
        return inactive;
      }

      return enrollmentExpired;
    },
  },
};
